'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _watchAppNotifier = require('common/components/mixins/watch-app-notifier');

var _watchAppNotifier2 = _interopRequireDefault(_watchAppNotifier);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _configEntry = require('./config-entry');

var _configEntry2 = _interopRequireDefault(_configEntry);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx(_button2['default'], {
    iconUri: 'v2/common/search_icon_white.svg'
});

var FaxLineConfigList = _react2['default'].createClass({
    displayName: 'FaxLineConfigList',


    mixins: [_watchAppNotifier2['default']],

    propTypes: {},

    getInitialState: function getInitialState() {
        var app = this.props.app || window.app;
        return {
            app: app,
            user: app.user,
            faxLines: app.user.getFaxLines(),
            teamMembers: app.serverSideGeneratedData.allTeamMembers, // app.user.getTeam().getMembers({ pageSize: Infinity }), // This should be allTeamMembers
            query: ''
        };
    },

    componentDidMount: function componentDidMount(rootNode) {
        // register to receive addedFaxLine events
        $(document).bind("addedFaxLine", this.handleAddedFaxLine); //FIXME: old jquery
    },

    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
        // FIXME: old jquery
        $(".fax-line-member-email-search").autocomplete({
            'source': this.getAutocompleteResults,
            'select': this.autocompleteMadeSelection
        });
    },

    // If there are more than this many fax lines, search functionality will be enabled.
    // Also, only this many fax lines will be displayed on page load.
    numFaxLinesForSearch: 5,

    // Maximum number of fax line config widgets to display (because rendering too many hangs the browser)
    maxFaxLineConfigsToDisplay: 50,

    // Returns whether search functionality should be enabled
    searchEnabled: function searchEnabled() {
        return this.state.faxLines.length > this.numFaxLinesForSearch;
    },

    // Strip a string of everything but digits and plus symbols
    // Example: "+1 (555) 444-3333" becomes "+15554443333"
    stripFaxNumberString: function stripFaxNumberString(text) {
        return text.replace(/[^\d+]/g, "");
    },

    // Provides search results to the autocomplete box
    getAutocompleteResults: function getAutocompleteResults(request, response) {
        var text = request.term;
        var textDigits = this.stripFaxNumberString(text);
        var matches = [];
        var limit = 10;

        if (textDigits.length > 0) {
            (this.state.faxLines || []).map(function (faxLine) {
                if (matches.length < limit && faxLine.number.includes(textDigits)) {
                    matches.push(hellofaxJS.formatInternationalFaxNumber(faxLine.number));
                }
            });
        }
        (this.state.teamMembers || []).map(function (teamMember) {
            if (matches.length < limit && teamMember.emailAddress.startsWith(text)) {
                matches.push(teamMember.emailAddress);
            }
        });

        response(matches);
    },

    // Invoked when an autocomplete item is selected
    autocompleteMadeSelection: function autocompleteMadeSelection(event, ui) {
        event.target.value = ui.item.value;
        this.commitSearchQuery(event.target.form);
    },

    // Save the search query, triggering a re-render with the results
    commitSearchQuery: function commitSearchQuery(form) {
        var query = form.elements[0].value;
        this.setState({ query: query });
    },

    // OnSubmit handler for search form
    searchFaxLines: function searchFaxLines(event) {
        event.preventDefault();

        // Try to close the autocomplete menu
        // FIXME: old jquery
        $(".fax-line-member-email-search").autocomplete("close");

        // Commit the search query
        var form = event.target;
        this.commitSearchQuery(form);
    },

    // OnChange handler for search input field
    searchTextChanged: function searchTextChanged(event) {
        // Clear the current search if the user clears the input
        if (event.target.value === "") {
            this.commitSearchQuery(event.target.form);
        }
    },

    handleAddedFaxLine: function handleAddedFaxLine(e) {
        this.state.faxLines.addFaxLine({ data: e.addedFaxLines[0] });
    },

    updateFaxLineStatusCode: function updateFaxLineStatusCode(guid, newStatusCode) {
        var faxLines = this.state.faxLines;
        for (var i in faxLines) {
            if (faxLines[i].guid === guid) {
                faxLines[i].statusCode = newStatusCode;
            }
        }
        this.setState({ faxLines: faxLines });
    },

    removeFaxLine: function removeFaxLine(faxLine) {
        var updatedFaxLines = this.state.faxLines.filter(function (candidate) {
            return candidate.guid !== faxLine.guid;
        });

        this.setState({ faxLines: updatedFaxLines });
    },

    render: function render() {
        // Get only the fax lines we wish to display right now (search functionality happens here)
        var searchEnabled = this.searchEnabled();
        var query = this.state.query;
        var queryExists = query.length > 0;
        var tooManyFaxLinesToDisplay = false;
        var needToSearchToSeeMore = false;
        var faxLines = (this.state.faxLines || []).filter(function (faxLine, i) {
            if (searchEnabled && queryExists) {
                // Return true if the number matches the query
                var queryDigits = this.stripFaxNumberString(query);
                console.log(faxLine.number);
                if (queryDigits.length > 0 && faxLine.number.includes(queryDigits)) {
                    return true;
                }

                // Return true if any user's email matches the query
                for (var j = 0; j < faxLine.teamMembers.length; j++) {
                    console.log(faxLine.teamMembers[j].emailAddress);
                    if (faxLine.teamMembers[j].emailAddress.startsWith(query)) {
                        return true;
                    }
                }

                // Don't show this FaxLine if it didn't match the query
                return false;
            } else {
                // If no query present, just show the first n FaxLines by default
                if (i >= this.numFaxLinesForSearch) {
                    needToSearchToSeeMore = true;
                    return false;
                } else {
                    return true;
                }
            }
        }.bind(this));

        if (faxLines.length >= this.maxFaxLineConfigsToDisplay) {
            // Over the limit. Hide this fax line and show a message to the user
            tooManyFaxLinesToDisplay = true;
            faxLines = faxLines.slice(0, this.maxFaxLineConfigsToDisplay);
        }

        // Get only the team members that aren't pending
        var teamMembers = (this.state.teamMembers || []).filter(function (tm) {
            return !tm.pending;
        });

        // Create the search form if search is supposed to be enabled
        var searchWidget;
        if (searchEnabled) {
            searchWidget = _jsx('div', {}, void 0, _jsx('div', {
                className: 'search-header'
            }, void 0, 'Manage fax numbers'), _jsx('form', {
                className: 'search-fax-lines',
                onSubmit: this.searchFaxLines
            }, void 0, _jsx('input', {
                type: 'text',
                placeholder: 'Fax number or email address',
                className: 'fax-line-member-email-search',
                onChange: this.searchTextChanged
            }), _ref));
        }

        // Create the configuration components for all the visible fax lines
        var faxLineConfigs = faxLines.map(function (faxLine) {
            return _jsx(_configEntry2['default'], {
                handleDelete: this.removeFaxLine,
                faxLine: faxLine,
                teamMembers: teamMembers,
                hasMultiple: faxLines.length > 1,
                app: this.props.app
            }, faxLine.number);
        }.bind(this));

        // Create the message to conditionally show at the end of the list
        var postMessage;
        if (tooManyFaxLinesToDisplay) {
            postMessage = _jsx('div', {
                className: 'search-footer-msg'
            }, void 0, 'Showing the the first ', this.maxFaxLineConfigsToDisplay, ' matches. Search for a more specific term to narrow the results.');
        } else if (needToSearchToSeeMore) {
            postMessage = _jsx('div', {
                className: 'search-footer-msg'
            }, void 0, 'Only showing ', this.numFaxLinesForSearch, ' fax lines. Perform a search using the form above to see more.');
        } else if (queryExists && faxLines.length == 0) {
            postMessage = _jsx('div', {
                className: 'search-footer-msg'
            }, void 0, 'No results found for ', _jsx('b', {}, void 0, query), '. Please try again.');
        }

        return _jsx('div', {
            id: 'fax_line_config'
        }, void 0, searchWidget, _jsx('div', {
            className: 'clearfix'
        }, void 0, faxLineConfigs), postMessage);
    }
});

module.exports = FaxLineConfigList;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/content/team/team-fax-lines/index.jsx
 ** module id = 803
 ** module chunks = 0
 **/